import MainLayout from '../../shared/Layouts/MainLayout'
import Segmented from '@/shared/Common/Segmented/index.tsx'
import DeviceMapContent from './components/DeviceMapContent/index.tsx'
import usePersistentState from '@/shared/hooks/usePersistentState/index.ts'
import EquipmentTab from '../Equipment/Tabs/EquipmentTab/index.tsx'
import css from './deviceMap.module.css'
import useTitle from '@/shared/hooks/useTitle'

const DeviceMap = () => {
  const [selectedTab, setSelectedTab] = usePersistentState<string>('map', 'map/selected-tab')
  useTitle(selectedTab === 'list' ? 'Список лифтов' : 'Карта')

  return (
    <MainLayout>
      <div className={css.pageWrapper} data-view={selectedTab}>
        <div className={css.toggleWrapper} data-view={selectedTab}>
          <Segmented
            size="middle"
            block
            options={[
              { label: 'Карта', value: 'map' },
              { label: 'Список лифтов', value: 'list' },
            ]}
            value={selectedTab}
            onChange={setSelectedTab as any}
          />
        </div>

        {selectedTab === 'list' ? (
          <div className={css.equipmentTabWrapper}>
            <div className={css.equipmentTabMainCard}>
              <EquipmentTab />
            </div>
          </div>
        ) : (
          <DeviceMapContent />
        )}
      </div>
    </MainLayout>
  )
}

export default DeviceMap
